(function () {
  if (window.location.href.indexOf("/products/") === -1) return;

  // ---------------- state ----------------
  const selectedVariants = { product1: null, product2: null, product3: null }; // stores product IDs

  // ---------------- helpers ----------------
  function idToKey(pickerId) {
    if (pickerId === "product-picker-1") return "product1";
    if (pickerId === "product-picker-2") return "product2";
    if (pickerId === "product-picker-3") return "product3";
    return null;
  }

  function currency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "₹";
  }

  function money(cents) {
    return `${currency()} ${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function safeParseMetafields() {
    try {
      const el = document.getElementById("variantMetafields");
      if (!el || !el.textContent) return {};
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      console.warn("[Pickers] metafields json invalid", e);
      return {};
    }
  }

  // product/handle from an option node
  function getProductIdFromOption($el) {
    return (
      $el.attr("data-product-id") ||
      $el.data("productId") ||
      $el.attr("data-id") ||
      ""
    );
  }
  function getHandleFromOption($el) {
    return $el.attr("data-handle") || $el.data("handle") || "";
  }

  // reflect image + label in the picker's selected header
  function reflectSelectionUI($picker, productOrNull, variantOrOption) {
    const label = variantOrOption.title || $(variantOrOption).find(".option-label").text();
    const img =
      (variantOrOption.featured_image && variantOrOption.featured_image.src) ||
      $(variantOrOption).find("img").attr("src") ||
      productOrNull?.featured_image ||
      "";

    $picker.find(".selected-label").text(label || "Selected");
    if ($picker.find(".selected-image").length === 0) {
      $picker
        .find(".selected-products-wrapper")
        .prepend(`<div class="selected-image"><img src="${img}" alt="${label}"></div>`);
    } else {
      $picker.find(".selected-image").html(`<img src="${img}" alt="${label}">`);
    }
  }

  // ---- price helpers (reused for totals) ----
  function priceFromDOM(pid) {
    if (!pid) return { price: 0, compare: 0 };
    const $opt = $(`.option-products-wrapper[data-product-id="${pid}"]`).first();
    return {
      price: Number($opt.attr("data-price") || 0),
      compare: Number($opt.attr("data-compare") || 0),
    };
  }

  function getPriceForProduct(pid, metafields) {
    if (!pid) return { price: 0, compare: 0 };
    if (metafields && metafields[pid]) {
      return {
        price: Number(metafields[pid].price || 0),
        compare: Number(metafields[pid].compare_at_price || 0),
      };
    }
    return priceFromDOM(pid);
  }

  // ---------------- UI text: Kaufe X Düfte ----------------
  function updateQuantityText() {
    const hasProduct2 = !!selectedVariants.product2;
    const $qtyEl = $(".custom-product-quantity");
    $qtyEl.text(hasProduct2 ? "Kaufe 2 Düfte" : "Kaufe 2 Düfte");
  }

  // ---------------- pricing (picker1+picker2) ----------------
  function updateTotals() {
    const metafields = safeParseMetafields();

    const p1id = selectedVariants.product1;
    const p2id = selectedVariants.product2;
    const p3id = selectedVariants.product3; // kept for completeness

    const p1 = getPriceForProduct(p1id, metafields);
    const p2 = getPriceForProduct(p2id, metafields);
    const p3 = getPriceForProduct(p3id, metafields); // not used in main total

    // normal pair total (picker 1 + picker 2) 
    const pairSum = (p1.price || 0) + (p2.price || 0);
    console.log('second product price' + p2.price);
    // update UI
    if(p2.price == 0){
      const newpairSum = (p1.price || 0) + (p1.price || 0);
      $(".custom-product-price").text(money(pairSum));
      $(".price_change").text(money(pairSum));
    }
    else{
    $(".price_change, .custom-product-price").text(money(pairSum));
    }
    $(".main-price").text(" - " + money(pairSum));

    // sale badge logic based on picker-1
    if (p1.compare > 0) {
      $(".compare_price_change").text(money(p1.compare)).show();
      $(".price__badge-sale").show();
    } else {
      $(".compare_price_change").hide();
      $(".price__badge-sale").hide();
    }

    // Kaufe text
    updateQuantityText();

    // update "free" totals (picker-3 + free product attribute)
    updateFreeTotals();
  }

  // ---------------- pricing (picker3 + free product) ----------------
  function updateFreeTotals() {
    const metafields = safeParseMetafields();

    // picker-3 selected
    const p3id = selectedVariants.product3;

    // static/externally-set variant on the free container
    const freeId = String(($(".custom-free-products").attr("data-free-product") || "").trim());

    const p3 = getPriceForProduct(p3id, metafields);
    const pf = getPriceForProduct(freeId, metafields);

    const freeSum = (p3.price || 0) + (pf.price || 0);

    // show the free products total
    $(".free_price_change s").text(money(freeSum));
    const hasProduct3 = !!selectedVariants.product3;
    const $qtyWEl = $(".dynamic_free_text");
    $qtyWEl.text(hasProduct3 ? "2x Tester-Bundle" : "2x Tester-Bundle");

  }

  // ---------------- init (no DOM mutations to the option list) ----------------
  function initAllPickers() {
    // Preselect first available option for picker-1 from existing HTML
    const $picker1 = $("#product-picker-1");
    if ($picker1.length) {
      const $firstAvailable = $picker1
        .find(".list-products-wrapper .option-products-wrapper")
        .filter(function () { return !$(this).is('[data-unavailable="true"]'); })
        .first();

      if ($firstAvailable.length) {
        const pid = String(getProductIdFromOption($firstAvailable) || "");
        selectedVariants.product1 = pid;

        // keep picker-1 attributes in sync
        $("#product-picker-1")
          .attr("data-handle", getHandleFromOption($firstAvailable))
          .attr("data-product-id", getProductIdFromOption($firstAvailable));

        const fakeVariant = {
          title: $firstAvailable.find(".option-label").text(),
          featured_image: { src: $firstAvailable.find("img").attr("src") || "" },
        };
        reflectSelectionUI($picker1, null, fakeVariant);

        setImage($(".custom-product-image-1"), fakeVariant.featured_image.src);
        updateTotals();
      }
    }

    // initial free totals calculation (in case data-free-product is already set)
    updateFreeTotals();
  }

  // ---------------- events (delegated) ----------------
  // open/close a picker's list
  $(document).on("click", ".selected-products-wrapper", function (e) {
    e.stopPropagation();
    const $this = $(this);
    const $list = $this.siblings(".list-products-wrapper");
    const isOpen = $this.hasClass("active");

    $(".list-products-wrapper").slideUp(150);
    $(".selected-products-wrapper").removeClass("active");

    if (!isOpen) {
      $this.addClass("active");
      $list.slideDown(150);
    }
  });

  // close all when clicking outside
  $(document).on("click", function () {
    $(".list-products-wrapper").slideUp(150);
    $(".selected-products-wrapper").removeClass("active");
  });

  function setImage($el, url) {
  if (!$el || !$el.length || !url) return;
  if ($el.is("img")) {
    $el.attr("src", url);
    if ($el.attr("srcset")) $el.attr("srcset", url);   // support srcset
    if ($el.attr("data-src")) $el.attr("data-src", url); // lazy loaders
  } else {
    $el.css("background-image", `url(${url})`);
  }
}


  // choosing an option (from your Liquid-rendered list)
  $(document).on("click", ".option-products-wrapper", function () {
    const $option = $(this);
    const $picker = $option.closest(".custom-choose-product");
    const key = idToKey($picker.attr("id"));
    if (!key) return;

    // sync picker dataset to the chosen option
    $picker
      .attr("data-handle", getHandleFromOption($option))
      .attr("data-product-id", getProductIdFromOption($option));

    const chosenId = String(getProductIdFromOption($option) || "");
    if (!chosenId) {
      console.warn("[Pickers] clicked option has no product id", this);
      return;
    }

    selectedVariants[key] = chosenId;

    const fakeVariant = {
      title: $option.find(".option-label").text(),
      featured_image: { src: $option.find("img").attr("src") || "" },
    };
    reflectSelectionUI($picker, null, fakeVariant);

    if (key === "product1") {
      $(".custom-product-image-1").attr("src", fakeVariant.featured_image.src);
    }
    if (key === "product2") {
      $(".custom-product-image-2").attr("src", fakeVariant.featured_image.src);
    }
    

    $picker.find(".list-products-wrapper").slideUp(150);
    $picker.find(".selected-products-wrapper").removeClass("active");

    updateTotals();
  });

  // keep form's parent class in sync (optional nicety)
  (function syncFormDisabledClass() {
    const submitBtn = document.querySelector(".product-form__submit");
    if (!submitBtn) return;
    const form = submitBtn.closest("form") || document.body;

    const apply = () => {
      if (submitBtn.disabled || submitBtn.classList.contains("disabled")) {
        form.classList.add("disabled");
      } else {
        form.classList.remove("disabled");
      }
    };
    apply();
    const observer = new MutationObserver(apply);
    observer.observe(submitBtn, { attributes: true, attributeFilter: ["disabled", "class"] });
  })();

  // Optional: auto-recalc when data-free-product changes dynamically
  (function observeFreeAttr() {
    const freeEl = document.querySelector(".custom-free-products");
    if (!freeEl) return;
    new MutationObserver(updateFreeTotals).observe(freeEl, {
      attributes: true,
      attributeFilter: ["data-free-product"]
    });
  })();

  // init from existing HTML only (no option-list mutations)
  document.addEventListener("DOMContentLoaded", initAllPickers);
  document.addEventListener("shopify:section:load", initAllPickers);
})();

